import * as services from '@partnershipsContext/application/services';

export type { TPartnershipGroupResponse,
  TContractCustomAttributesSchemaResponse,
  TContractCustomColumnsResponse } from '@partnershipsContext/application/services/types';

export const {
  fetchPartnershipPopupInfo,
  fetchPartnerGroups,
  getContractCustomAttributesSchema,
  getContractCustomColumns,
  updatePartnershipResourceDriverDocumentStatuses,
  updatePartnershipResourceVehicleDocumentStatuses,
} = services;
